import Ok from "./Ok";
export default Ok;
